import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};

const StatTile = ({ icon, label, value }) => (
  <div
    style={{
      border: "1px solid rgba(255,255,255,0.06)",
      borderRadius: "6px",
      padding: "14px",
      textAlign: "center"
    }}
  >
    <i className={`${icon} mb-2`} style={{ fontSize: "22px", color: "#f97316" }}></i>

    <p className="text-muted mb-1" style={{ fontSize: "12px" }}>
      {label}
    </p>

    <h4 className="mb-0">{value}</h4>
  </div>
);

const MalwareOTThreatDetection = () => {
  return (
    <Card style={{...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-bug-line" style={pageIconStyle} ></i>
          </div>
          Malware & OT Threat Detection
        </h5>
      </CardHeader>

      <CardBody>

        <Row className="g-3 mb-3">

          <Col md={4}>
            <StatTile
              icon="ri-bug-line"
              label="MALWARE HITS"
              value="02"
            />
          </Col>

          <Col md={4}>
            <StatTile
              icon="ri-radar-line"
              label="C2 COMMUNICATION"
              value="04"
            />
          </Col>

          <Col md={4}>
            <StatTile
              icon="ri-flashlight-line"
              label="SUSPICIOUS USB"
              value="12"
            />
          </Col>

        </Row>

        {/* Alert */}
        <div
          className="d-flex align-items-center"
          style={{
            border: "1px solid rgba(239,68,68,0.3)",
            borderRadius: "6px",
            padding: "12px",
            background: "rgba(239,68,68,0.05)"
          }}
        >
          <i
            className="ri-error-warning-line me-3"
            style={{ color: "#ef4444", fontSize: "18px" }}
          ></i>

          <span>
            <strong>Ransomware Indicator Detected:</strong>{" "}
            Encrypted file extensions found on{" "}
            <span style={{ color: "#f97316" }}>
              ENG_WS_77
            </span>
          </span>
        </div>

      </CardBody>

    </Card>
  );
};

export default MalwareOTThreatDetection;